module.exports = __webpack_public_path__ + "img/example_print_step2.032db848.png";